import { MetadataOptionsQuestion, MeterConfiguration } from '../types';

/**
 * Normalizes a question's meter data into the `meterConfigurations` array shape.
 *
 * Questions saved before the array existed carry a bare `meterId` with a flat
 * `associatedQuestions`, or `updateData: '1'` for the legacy location mode. Anything that
 * decides whether a question is wired to a meter has to read through this, not the raw field:
 * reading `meterConfigurations` directly silently treats every pre-migration question as
 * unwired.
 *
 * It lives in `utils/` rather than next to the form builder because both the builder and the
 * shared link predicate need it, and `utils/` must not import from `components/`. The builder's
 * `assetsUtils/meterConfigurationsUtils` re-exports this one instead of keeping a second copy,
 * which is the point: two normalizers drift, and the drift is invisible until a legacy question
 * resolves on one surface and not on another.
 */
export const normalizeMeterConfigurations = (
  question: MetadataOptionsQuestion,
): MeterConfiguration[] => {
  if (question.meterConfigurations?.length) {
    return question.meterConfigurations;
  }
  if (question.meterId) {
    return [
      {
        meterId: question.meterId,
        associatedQuestions: question.associatedQuestions ?? [],
      },
    ];
  }
  if (question.updateData === '1') {
    return [
      {
        meterId: '',
        associatedQuestions: question.associatedQuestions ?? [],
        isLocation: true,
      },
    ];
  }
  return [];
};
